// Planes comerciales del agente (Maxi). El valor guardado en agents.plan es la key
// ('business' | 'pro' | 'premium') o null = "sin plan".
export type PlanKey = 'business' | 'pro' | 'premium';

export const PLAN_META: Record<PlanKey, { label: string; price: number; contacts: number; badgeClass: string }> = {
  business: { label: 'Business', price: 49, contacts: 1000, badgeClass: 'bg-blue-100 text-blue-700' },
  pro: { label: 'Pro', price: 129, contacts: 3000, badgeClass: 'bg-purple-100 text-purple-700' },
  premium: { label: 'Premium', price: 299, contacts: 10000, badgeClass: 'bg-amber-100 text-amber-700' },
};

export const PLAN_OPTIONS = (Object.keys(PLAN_META) as PlanKey[]).map((key) => ({ key, ...PLAN_META[key] }));

// Etiqueta corta para el <select> (ej: "Business — $49 (1,000 contactos)")
export const planOptionLabel = (key: PlanKey): string => {
  const p = PLAN_META[key];
  return `${p.label} — $${p.price} (${p.contacts.toLocaleString('es')} contactos)`;
};
